/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

export default class PredictionUtils {
	/**
	 * Generate request Body to send to the server.
	 * @param  {string} modelName name of the ML model
	 * @returns {Object}  request body object
	 */
	static getRequestBodyBasedOnModel(modelName: string) {
		let requestBody = {};

		switch (modelName) {
			case 'apps-entitlement-based-autoranker':
				requestBody = {
					endpoint: modelName,
					contentType: 'application/json',
					payload: {
						data: {instances: ['ccsn_direct_individual'], configuration: {k: 10}},
					},
				};
				break;
		}

		return requestBody;
	}
}
